import {
  DATE_FORMATS,
  formatDateDuration,
  formatStartTime,
  formatYearToLocaleString,
  timeWithin,
} from '~/shared/helpers/date'

type EpisodeInfoFormattingSource = {
  duration?: number | null
  length?: string | null
  releaseTime?: number | null
  releaseTimeFormatted?: string | null
  year?: number | null
  resolution?: string | null
}

export const formatEpisodeInfoLength = (
  episode: EpisodeInfoFormattingSource,
  { short = false }: { short?: boolean } = {}
): string | null => {
  if (episode.duration != null) {
    const { hours, minutes } = timeWithin(episode.duration)
    const formatted = formatDateDuration({
      duration: { hours, minutes },
      short,
    })

    // `formatTimeString` leaves a space after every token, so `1 hour 38 minutes`
    // becomes `1h  38m `. Collapse that only on the short path — InfoPopup keeps
    // the long form, and other `formatDateDuration({ short: true })` callers keep
    // their existing strings.
    return short ? formatted.replace(/\s+/g, ' ').trim() : formatted
  }

  return episode.length ?? null
}

export const formatEpisodeInfoReleaseTime = (
  episode: EpisodeInfoFormattingSource
): string | null => {
  if (episode.releaseTimeFormatted) return episode.releaseTimeFormatted
  if (episode.releaseTime) {
    return formatStartTime(episode.releaseTime * 1000, DATE_FORMATS.DD_MMM_YYYY)
  }
  if (episode.year) {
    return formatYearToLocaleString(episode.year)
  }

  return null
}

export const formatEpisodeInfoLabels = (
  episode: EpisodeInfoFormattingSource
): string[] => {
  const length = formatEpisodeInfoLength(episode)
  const releaseTime = formatEpisodeInfoReleaseTime(episode)

  return [length, releaseTime].filter((value): value is string =>
    Boolean(value)
  )
}
